<template>
  <footer class="o-container">
    <div class="footer o-container-child">
      <div class="contact-address">
        <aside>
          <h2>Clinical Outcomes Research</h2>
          <p>Department of Otolaryngology-Head &#38; Neck Surgery</p>
          <a href="mailto:piccirij@wustl.edu">piccirij@wustl.edu</a>
          <p>Campus Box 8115</p>
          <p>660 S. Euclid Ave.</p>
          <p>St. Louis, MO, 63110</p>
          <p>314-362-8641</p>
        </aside>
        <hr />
      </div>
      <p class="copyright">{{ copyright }}</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: ['copyright'],
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville&display=swap');
@import './assets/Shared.css';

footer {
  font-family: Source Sans Pro;
}

.o-container {
  background-color: #3d3d3d;
  line-height: 1.25;
  font-size: 14px;
  padding: 2em 0;
  margin-top: 2em;
}

.o-container aside {
  line-height: 1;
  margin-bottom: 1.8em;
}

.o-container aside a {
  color: white !important;
  text-decoration: underline;
}

.o-container aside > h2 {
  font-size: 1.2rem;
  font-family: 'Libre Baskerville', 'Times New Roman', serif;
  font-weight: 400;
  text-transform: none;
  margin: 0px 0px 10px 0px;
}

.o-container aside > p {
  margin: 5px 0px;
}

.o-container .copyright {
  margin-top: 1em;
  margin-bottom: 0px;
  text-align: left;
}
</style>
